export const players = [
  {
    id: 'youssef-maktouf',
    name: 'Youssef Maktouf',
    number: '22',
    position: 'Gardien principal',
    image: '/assets/joueurs/youssef maktouf.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'moatez-hanzouli',
    name: 'Moatez Hanzouli',
    number: '1',
    position: 'Gardien',
    image: '/assets/joueurs/hanzouli.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'sabri-saidi',
    name: 'Sabri Saidi',
    number: '—',
    position: 'Gardien',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'mohamed-amine-allela',
    name: 'Mohamed Amine Allela',
    number: '24',
    position: 'Défenseur central',
    image: '/assets/joueurs/allela.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'malek-doukali',
    name: 'Malek Doukali',
    number: '20',
    position: 'Défenseur central',
    image: '/assets/joueurs/doukali.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'farouk-bougatfa',
    name: 'Farouk Bougatfa',
    number: '2',
    position: 'Défenseur central',
    image: '/assets/joueurs/bougatfa.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'hani-amamou',
    name: 'Hani Amamou',
    number: '26',
    position: 'Défenseur central',
    image: '/assets/joueurs/amamou.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'firas-akermi',
    name: 'Firas Akermi',
    number: '14',
    position: 'Défenseur central',
    image: '/assets/joueurs/Akermi.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'rayane-rehimi',
    name: 'Rayane Rehimi',
    number: '4',
    position: 'Arrière gauche',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'yassine-arfaoui',
    name: 'Yassine Arfaoui',
    number: '3',
    position: 'Arrière gauche',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'mohamed-aziz-gasmi',
    name: 'Mohamed Aziz Gasmi',
    number: '31',
    position: 'Arrière droit',
    image: '/assets/joueurs/guesmi.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'yassine-kchouk',
    name: 'Yassine Kchouk',
    number: '23',
    position: 'Arrière droit',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'aziz-gueblia',
    name: 'Aziz Gueblia',
    number: '5',
    position: 'Arrière droit',
    image: '/assets/joueurs/zarga.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'achref-ferchichi',
    name: 'Achref Ferchichi',
    number: '30',
    position: 'Milieu défensif',
    image: '/assets/joueurs/ferchichi.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'alaeddine-dridi',
    name: 'Alaeddine Dridi',
    number: '6',
    position: 'Milieu central',
    image: '/assets/joueurs/dridi.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'iyed-midani',
    name: 'Iyed Midani',
    number: '17',
    position: 'Milieu central',
    image: '/assets/joueurs/iyed.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'bilel-ouni',
    name: 'Bilel Ouni',
    number: '13',
    position: 'Milieu central',
    image: '/assets/joueurs/bilel ouni.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'muhamed-lamine-traore',
    name: 'Muhamed Lamine Traoré',
    number: '27',
    position: 'Milieu central',
    image: '/assets/joueurs/traoré .png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'wassim-chihi',
    name: 'Wassim Chihi',
    number: '7',
    position: 'Milieu offensif',
    image: '/assets/joueurs/chihi.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'mohamed-aziz-chaabane',
    name: 'Mohamed Aziz Chaabane',
    number: '10',
    position: 'Milieu offensif',
    image: '/assets/joueurs/chaabene.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'bilel-mejri',
    name: 'Bilel Mejri',
    number: '19',
    position: 'Ailier droit',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'mohamadou-lamine-ba',
    name: 'Mohamadou Lamine Ba',
    number: '18',
    position: 'Ailier droit',
    image: '/assets/joueurs/ba.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'sada-diallo',
    name: 'Sada Diallo',
    number: '8',
    position: 'Ailier droit',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'olamilekan-nurudeen-ayinde',
    name: 'Olamilekan Nurudeen Ayinde',
    number: '28',
    position: 'Avant-centre',
    image: '/assets/joueurs/ayendé.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'wahid-timi',
    name: 'Wahid Timi',
    number: '11',
    position: 'Avant-centre',
    image: '/assets/joueurs/timi.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'zied-berrima',
    name: 'Zied Berrima',
    number: '29',
    position: 'Avant-centre',
    image: '/assets/joueurs/berrima.png',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'marius-glo',
    name: 'Marius Glo',
    number: '—',
    position: 'Avant-centre',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'omar-faty',
    name: 'Omar Faty',
    number: '15',
    position: 'Avant-centre',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'chiheb-abdelli',
    name: 'Chiheb Abdelli',
    number: '12',
    position: 'Attaquant',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'chadi-mhamdi',
    name: 'Chadi Mhamdi',
    number: '9',
    position: 'Attaquant',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'favour-onyemechi-adegbile',
    name: 'Favour Onyemechi Adegbile',
    number: '12',
    position: 'Avant-centre',
    jerseyImage: '/assets/home 1.png',
  },
  {
    id: 'mohamed-aziz-khelifi',
    name: 'Mohamed Aziz Khelifi',
    number: '—',
    position: 'Attaquant',
    jerseyImage: '/assets/home 1.png',
  },
];

export const getPlayer = (playerId) => players.find((player) => player.id === playerId) || players[0];
